import AjaxPopup from "../components/popup";

export default function bindDataActions() {
    bindActions();
    bindThemesUrls();
}

function bindActions() {
    const nodes = $("[data-action]");
    if (nodes.length == 0) {
        return false;
    }

    $(nodes).each(function () {
        const action = $(this).attr("data-action");

        $(this).on("click", function (event) {

        })
        switch (action) {
            case "show":
                bindShow(this);
                break;
            case "submit":
                bindFormSubmit(this);
                break;
            case "ajax-popup":
                bindAjaxPopup(this);
                break;
        }
    })
}

function bindShow(node) {
    const targetId = $(node).attr("data-target");
    const target = $(`[data-id=${targetId}]`);
    if (target.length == 0) {
        return false;
    } 

    $(target).on("click", function (event) {
        event.stopPropagation();
    })

    $(node).on("click", function (event) {
        function hideList(event) {
            const eventTargetId = $(event.target).attr("data-id");
            if (eventTargetId == targetId) {
                return false;
            }

            $(target).removeClass("active");
            window.removeEventListener("click", hideList);

            event.preventDefault();
            return true;
        }

        if ($(target).hasClass("active")) {
            $(target).removeClass("active");
            window.removeEventListener("click", hideList);
        } else {
            $(target).addClass("active");
            event.stopPropagation();
            window.addEventListener("click", hideList);
        }
    })
}

function bindThemesUrls() {
    const parent = $("#admin-panel .themes-list");
    if (parent.length == 0) {
        return false;
    }

    $(parent).find("[data-url]").each(function () {
        const url = $(this).attr("data-url");
        $(this).on("click", function (ev) {
            fetch(url)
                .then(resp => resp.text())
                .then(answ => {
                    document.location.reload();
                })
                .catch(err => console.log(err))
        })
    })
}

function bindFormSubmit(node) {
    const action = $(node).attr("data-on");
    const form = $(node).attr("data-form");

    if (action === undefined || form === undefined) {
        return;
    }

    switch (action) {
        case "change":
            $(node).on("change", function (event) {
                $("#" + form).submit();
            })
            break;
    }
}

function bindAjaxPopup(node) {
    const popup = new AjaxPopup();

    $(node).on("click", function (event) {
        const dataUrl = $(this).attr("data-source");

        popup.setLoader();
        popup.show();
        fetch(dataUrl)
            .then(resp => {
                if (resp.status != 200) {
                    return Promise.reject()
                }
                return resp.text()
            })
            .then(answ => {
                popup.setContent(answ);
            })
            .catch(err => {
                popup.setError();
            })
    });
}
